module.exports = __webpack_public_path__ + "assets/img/CreateAccount@2x.7ab86308.png";